export const addCurrencySign = (
  value: number,
  options: { label: string; value: number }[]
) => {
  if (options?.length) {
    const exampleLabel = options[0].label;
    const match = exampleLabel.match(/(\d+([\.\,]+)?(\d+)?)/gm);
    const newLabel = !!match
      ? exampleLabel.replace(match[0], value.toString())
      : '';

    return newLabel;
  }

  return value.toString();
};
